/* tslint:disable */
/* eslint-disable */
export enum FinancialSummaryStatus {
  Pending = 'Pending',
  Approved = 'Approved',
  Rejected = 'Rejected',
  PaymentOrder = 'PaymentOrder',
  IssueOrder = 'IssueOrder'
}
